"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import { Comments } from "@fuma-comment/react";
import { useRouter } from "next/navigation";
export function CommentsWidget(t0) {
  const $ = _c(11);
  const {
    page,
    className,
    signInRedirectUrl
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== router) {
    t1 = signInRedirectUrl_0 => {
      router.push(`/sign-in${signInRedirectUrl_0 ? `?callbackUrl=${signInRedirectUrl_0}` : ""}`);
    };
    $[0] = router;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const signIn = t1;
  let t2;
  if ($[2] !== className) {
    t2 = cn(className, "w-full min-h-24");
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== signIn || $[5] !== signInRedirectUrl) {
    t3 = {
      type: "api",
      signIn: () => signIn(signInRedirectUrl)
    };
    $[4] = signIn;
    $[5] = signInRedirectUrl;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== page || $[8] !== t2 || $[9] !== t3) {
    t4 = <Comments page={page} className={t2} auth={t3} />;
    $[7] = page;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}